import {
  DEFAULT,
  PAYMENTS,
  ALL,
  BATCH_CAPTURE,
  ORDERS,
  REFUNDS,
  INITIATED_REFUNDS,
  BATCH_REFUNDS,
  AUTO_REFUNDS,
  DISPUTES,
  SUSPICIOUS,
  STANDARD,
  INSTANT,
  VENDOR,
  ON_DEMAND,
  EMAIL_LOGIN,
  ALIAS_LOGIN,
  ROUTER,
  GATEWAYS,
  GATEWAYS_CONFIGURATION,
  ANALYTICS,
  LOGS,
  CONFIGURATION,
  SERVICE_ALERTS,
  SCHEDULE_REPORT,
  ROUTER_ANALYTICS,
  ACTION_REQUIRED,
  UNDER_REVIEW,
  ALL_DISPUTES,
  EASY_SPLIT_SETTLEMENT,
  SCHEDULED,
  ALERTS,
  VERIFIED,
  EXPIRED,
} from 'utils/constants';

import { CLOSED } from '../containers/Disputes/constants';

export default {
  ERROR_PAGE: 'Error Page',
  ONBOARDING: {
    SWITCH_SIGNUP: 'Login_Page_Button_Sign_Up',
    SWITCH_LOGIN: 'Signup_Page_Button_Log_In',
  },
  SIGNUP_NEW: 'Signup',
  LOGIN: 'Login',
  SIGNUP: {
    STEP_1: {
      EMAIL: 'Signup email entered',
      PASSWORD: 'Signup password entered',
      VIEW_PASSWORD: 'Signup view Password',
      READ_TNC: 'Signup_Page_Link_Terms_&_Conditions',
      CREATE_ACCOUNT: 'Signup_Page_Primary_Button_Continue',
      CONTACT_US: 'Signup_Page_Secondary_Button_Contant_Us',
      REFERRAL_CODE: 'Referral Code entered',
      TOGGLE_REFERRAL_CODE: 'Signup_Page_Button_Have_A_Referral_Code',
    },
    STEP_2: {
      SELECT_COUNTRY_CODE: 'Signup phone country code',
      PHONE_NUMBER: 'Signup phone number entered',
      GOTO_DASHBOARD: 'Signup step 2 Complete click',
      HAVE_COUPON_CODE: 'Signup_Page_Button_Have_A_Coupon_Code',
      REDEEM_NOW: 'Voucher Redeem now clicked on signup',
      VOUCHER_RESPONSE: 'Voucher API Response on signup',
      CREATE_ACCOUNT:
        'Signup_Page_Create_Your_Account_Primary_Button_Create_Account',
    },
  },
  [EMAIL_LOGIN]: {
    TAB: 'Tabs',
    EMAIL: 'Login email entered',
    PASSWORD: 'Login password entered',
    FORGOT_PASSWORD: 'Login_Page_Button_Forgot_Password',
    LOGIN_BTN: 'Login_Page_Email_Id_Primary_Button_Log_In',
    LOGIN: 'Login to dashboard',
  },
  [ALIAS_LOGIN]: {
    ACCOUNT_NAME: 'Alias login enter account name',
    USERNAME: 'Alias login enter username',
    PASSWORD: 'Alias login enter password',
    LOGIN_BTN: 'Login_Page_Account_Alias_Primary_Button_Log_In',
  },
  GOOGLE_LOGIN: {
    NO_PASSWARD: 'Login and no password is found',
    CREATE_ACCOUNT_POPUP: 'Create account clicked on pop up',
    GOOGLE_LOGIN_BTN: 'Google login clicked',
    LOGIN_SUCCESS: 'Login to dashboard success',
    PRIVACY_POLICY: 'Login_Page_Link_Privacy_Policy',
    TERMS_OF_SERVICE: 'Login_Page_Link_Terms_Of_Service',
  },
  GOOGLE_PLAY: 'Login_Page_Link_Google_Play',
  APPLE_APP_STORE: 'Login_Page_Link_App_Store',
  KNOW_MORE_LOGIN: 'Login_Page_Link_Know_More',
  FORGOT_PASSWORD: {
    EMAIL: 'Forgot Password Email ID Entered',
    SEND: 'Forgot_Password_Primary_Button_Send_Email',
    RESEND: 'Forgot_Password_Button_Resend_The_Email',
    BACK_TO_LOGIN: 'Forgot_Password_Button_Back_To_Log_In',
  },
  TNC: {
    SIGNUP_ACCEPT: 'TnC Signup accept',
    PRODUCT_ACCEPT: 'TnC Product accept',
    PRODUCT_SKIP: 'TnC Product - Skip',
  },
  LANDING_PAGE: {
    CUSTOM_BANNER_CLICK: 'Custom_Banner_Clicked',
    VIEW: 'View_Landing_Page',
    SWITCH_ENV: 'ML env switch',
    DEVELOPERS_DOCS: 'ML click developers docs',
    API_CHANGELOG: 'ML click  API Changelog',
    STATUS_PAGE: 'ML click  Status Page',
    CLICK_FAQ: 'ML click FAQ',
    TRY_TEST_ENV: 'ML click Try Test env',
    ACCESS_PRODUCT: 'ML click Access Product',
    VIEW_DOCS: 'ML click View Docs',
    REQUEST_ACTIVATION: 'Click Request Activation',
    REDEEM_VOUCHER: 'Click Redeem Now',
    ENTER_CODE: 'Click Redeem',
    VOUCHER_RESPONSE: 'Voucher API Response',
    ACTIVATE: 'Click on "Activate" on banner',
    CONTINUE_ACTIVATION: 'Click on "continue Activation" on banner',
    SIGN_AGREEMENT: 'Click on "sign agreement"',
  },
  VIDEO_EMBED: {
    SUMMARY: 'summary_view_help_video',
    TRANSACTIONS: {
      [ALL]: 'transactions_view_help_video',
      [BATCH_CAPTURE]: 'batch_capture_view_help_video',
      [INITIATED_REFUNDS]: 'refunds_view_help_video',
      [BATCH_REFUNDS]: 'batch_refunds_view_help_video',
      [DISPUTES]: 'disputes_view_help_video',
      [SUSPICIOUS]: 'suspicious_view_help_video',
    },
    SETTLEMENTS: {
      [STANDARD]: 'standard_settlements_view_help_video',
      [INSTANT]: 'instant_settlememts_view_help_video',
      [VENDOR]: 'vendor_settlements_view_help_video',
    },
    EASY_SPLIT: 'easy_split_view_help_video',
    REPORTS: 'reports_view_help_video',
  },
  DASHBOARD_CONTAINER: {
    USER_PERSONA_FORM_CLOSE: 'User Persona - Cross on Screen',
  },
  TIMELINE: {
    SAVE_PNG: 'timeline_save_as_png_click',
    REFUND_CTA: 'timeline_refund_button_click',
    RISK_COMMENT_CTA: 'timeline_risk_respond_button_click',
    DISPUTE_COMMENT_CTA: 'timeline_dispute_respond_button_click',
    VOID: 'timeline_void_button_click',
    CAPTURE: 'timeline_capture_button_click',
    VIEW: 'timeline_view_page_view',
  },
  SUMMARY: {
    VIEW: 'summary_menu_click',
    UNSETTLED_AMOUNT: 'summary_check_unsettled_amount_click',
    RECENT_SETTLEMENT: 'summary_recent_settlement_card_click',
    OPEN_DISPUTES: 'summary_open_disputes_card_click',
    SUSPICIOUS_TRANSACTIONS: 'summary_suspicious_transactions_card_click',
    DATE_RANGE_FILTER: 'summary_date_range_select',
    SETTLEMENTS_UNIFICATION_REQUESTED: 'settlements_unification_requested',
    TOKEN_VAULT_STRIP: 'token_vault_interest_strip_click',
    INTEGRATION_FORM: {
      INTEGRATION_FORM_FILLING_START: `Explore Your Integration - Let's get started`,
      INTEGRATION_FORM_OPEN_ON_BUTTON_CLICK: `Explore Your Integration Icon Clicked`,
      INTEGRATION_FORM_SUBMIT: `Explore Your Integration Form Submit`,
      INTEGRATION_FORM_DISMISS: `Explore Your Integration Form Dismiss`,
    },
  },
  TRANSACTIONS: {
    VIEW: 'transactions_menu_click',
    [PAYMENTS]: {
      VIEW: 'payments_tab_click',
      EXPORT_TO_CSV: 'payments_export_button_click',
      REFUND_CTA: 'payments_initiate_refund_cta_click',
      BATCH_CAPTURE_CTA: 'batch_capture_download_cta_click',
      DOWNLOAD_SAMPLE_FILE: 'batch_capture_download_sample_file_click',
      TABLE_ROW_CLICK: 'payments_table_row_click',
      TABLE_NEXT_BUTTON_CLICK: 'payments_table_next_button',
      TABLE_PREV_BUTTON_CLICK: 'payments_table_prev_button',
      TABLE_CREATE_PAYMENT_LINK_CTA: 'payments_table_create_payment_link_cta',
      [ALL]: {
        VIEW: 'payments_all_tab_click',
        DATE_RANGE_FILTER: 'payments_date_range_select',
        SEARCH: 'payments_search_applied',
        FILTERS: 'payments_filters_applied',
        PAGE_SIZE: 'payments_page_size_change',
      },
      [BATCH_CAPTURE]: {
        VIEW: 'batch_capture_tab_click',
        DATE_RANGE_FILTER: 'batch_capture_date_range_select',
        SEARCH: 'batch_capture_search_applied',
        FILTERS: 'batch_capture_filters_applied',
        PAGE_SIZE: 'batch_capture_page_size_change',
        UPLOAD_SUCCESS: 'batch_capture_upload_file_success',
        UPLOAD_FAILED: 'batch_capture_upload_file_failed',
      },
    },
    [ORDERS]: {
      VIEW: 'orders_tab_click',
      EXPORT_TO_CSV: 'orders_export_button_click',
      PAGE_SIZE: 'orders_page_size_change',
      TABLE_ROW_CLICK: 'orders_table_row_click',
      TABLE_NEXT_BUTTON_CLICK: 'orders_table_next_button',
      TABLE_PREV_BUTTON_CLICK: 'orders_table_prev_button',
      VIEW_PAGE: 'Page_Viewed_orders_description_page',
      COPY_FIELD: 'orders_details_field_copied',
      TABLE_NEXT_BUTTON_CLICK_DESCRIPTION:
        'orders_description_table_next_button',
      TABLE_PREV_BUTTON_CLICK_DESCRIPTION:
        'orders_description_table_prev_button',
      [DEFAULT]: {
        DATE_RANGE_FILTER: 'orders_date_range_select',
        SEARCH: 'orders_search_applied',
        FILTERS: 'orders_filters_applied',
      },
    },
    [REFUNDS]: {
      VIEW: 'refunds_tab_click',
      BATCH_REFUNDS_CTA: 'batch_refunds_download_cta_click',
      DOWNLOAD_SAMPLE_FILE: 'batch_refunds_download_sample_file_click',
      SET_PREFERENCES: 'batch_set_preferences_click',
      NAVIGATE_TO_BATCH_REFUNDS_CTA: 'Navigate_To_Batch_Refunds_CTA',
      REFUNDS_DETAIL_VIEW: 'Page_Viewed_refunds_detail_page',
      REFUNDS_DETAIL_BACK_BUTTON_CLICK: 'refunds_detail_back_button_click',
      COPY_FIELD: 'refunds_details_field_copied',
      REFUNDS_DETAIL_TOGGLE_EXPAND: 'refunds_detail_toggle_expand',
      REFUNDS_DETAIL_TRANSACTION_NAVIGATE_CLICK: 'refunds_detail_payment-details_navigate_click',
      [INITIATED_REFUNDS]: {
        VIEW: 'initiated_refunds_tab_click',
        EXPORT_TO_CSV: 'initiated_refunds_export_button_click',
        DATE_RANGE_FILTER: 'initiated_refunds_date_range_select',
        SEARCH: 'initiated_refunds_search_applied',
        FILTERS: 'initiated_refunds_filters_applied',
        PAGE_SIZE: 'initiated_refunds_page_size_change',
        TABLE_NEXT_BUTTON_CLICK: 'initiated_refunds_table_next_button',
        TABLE_PREV_BUTTON_CLICK: 'initiated_refunds_table_prev_button',
      },
      [BATCH_REFUNDS]: {
        VIEW: 'batch_refunds_tab_click',
        DATE_RANGE_FILTER: 'batch_refunds_date_range_select',
        SEARCH: 'batch_refunds_search_applied',
        FILTERS: 'batch_refunds_filters_applied',
        PAGE_SIZE: 'batch_refunds_page_size_change',
        UPLOAD_SUCCESS: 'batch_refund_upload_file_success',
        UPLOAD_FAILED: 'batch_refund_upload_file_failed',
        TABLE_NEXT_BUTTON_CLICK: 'batch_refunds_table_next_button',
        TABLE_PREV_BUTTON_CLICK: 'batch_refunds_table_prev_button',
        VIEW_PAGE: 'Page_Viewed_batch_refunds_view_page',
      },
      [AUTO_REFUNDS]: {
        VIEW: 'auto_refunds_tab_click',
        EXPORT_TO_CSV: 'auto_refunds_export_button_click',
        DATE_RANGE_FILTER: 'auto_refunds_date_range_select',
        SEARCH: 'auto_refunds_search_applied',
        FILTERS: 'auto_refunds_filters_applied',
        PAGE_SIZE: 'auto_refunds_page_size_change',
        TABLE_NEXT_BUTTON_CLICK: 'auto_refunds_table_next_button',
        TABLE_PREV_BUTTON_CLICK: 'auto_refunds_table_prev_button',
      },
    },
    [DISPUTES]: {
      TABLE_NEXT_BUTTON_CLICK: 'disputes_table_next_button',
      TABLE_PREV_BUTTON_CLICK: 'disputes_table_prev_button',
      [ACTION_REQUIRED]: {
        VIEW: 'action_required_disputes_tab_click',
        EXPORT_TO_CSV: 'action_required_disputes_export_button_click',
        DUE_TODAY_CARD_CLICK: 'due_today_card_clicked',
        DUE_TOMORROW_CARD_CLICK: 'due_tomorrow_card_clicked',
        INSUFFICIENT_EVIDENCE_CARD_CLICK: 'insufficient_evidence_card_clicked',
        DISPUTE_INFO_DOCS_CLICK: 'disputes-info-docs-click',
        DATE_RANGE_FILTER: 'action_required_disputes_date_range_select',
        SEARCH: 'action_required_disputes_search_applied',
        FILTERS: 'action_required_disputes_filters_applied',
      },
      [UNDER_REVIEW]: {
        VIEW: 'under_review_disputes_tab_click',
        EXPORT_TO_CSV: 'under_review_disputes_export_button_click',
        DATE_RANGE_FILTER:
          'under_review_disputes_under_review_date_range_select',
        SEARCH: 'under_review_disputes_search_applied',
        FILTERS: 'under_review_disputes_filters_applied',
        DISPUTE_REMARKS_CLICK: 'dispute-remarks-click',
      },
      [CLOSED]: {
        VIEW: 'closed_disputes_tab_click',
        EXPORT_TO_CSV: 'closed_disputes_export_button_click',
        MERCHANT_WON_CARD_CLICK: 'merchant_won_card_clicked',
        MERCHANT_LOST_CARD_CLICK: 'merchant_lost_card_clicked',
        MERCHANT_ACCEPTED_CARD_CLICK: 'merchant_accepted_card_clicked',
        DATE_RANGE_FILTER: 'closed_disputes_date_range_select',
        SEARCH: 'closed_disputes_search_applied',
        FILTERS: 'closed_disputes_filters_applied',
      },
      [ALL_DISPUTES]: {
        VIEW: 'all_disputes_tab_click',
        EXPORT_TO_CSV: 'all_disputes_export_button_click',
        DATE_RANGE_FILTER: 'all_disputes_date_range_select',
        SEARCH: 'all_disputes_search_applied',
        FILTERS: 'all_disputes_filters_applied',
      },
    },
    [SUSPICIOUS]: {
      VIEW: 'suspicious_tab_click',
      EXPORT_TO_CSV: 'suspicious_export_button_click',
      PAGE_SIZE: 'suspicious_page_size_change',
      COMMENT_CTA: 'suspicious_comment_cta_click',
      [DEFAULT]: {
        DATE_RANGE_FILTER: 'suspicious_date_range_select',
        SEARCH: 'suspicious_search_applied',
        FILTERS: 'suspicious_filters_applied',
      },
    },
  },
  DISPUTE_DETAILS: {
    VIEW: 'dispute_details_page_view',
    DISPUTE_REMARKS_CLICK: 'dispute-remarks-click',
  },
  TAKE_ACTION_MODAL: {
    TAKE_ACTION_BUTTON_CLICK: 'take_action_button_clicked',
    UPLOAD_EVIDENCE_BUTTON_CLICK: 'upload_evidence_button_clicked',
    UPLOAD_EVIDENCE_BUTTON_CLICK_UNDER_REVIEW:
      'upload_evidence_button_clicked_under_review',
    ACCEPT_DISPUTE_RADIO_BUTTON_CLICK: 'accept-dispute-radio-button-click',
    CONTEST_DISPUTE_RADIO_BUTTON_CLICK: 'contest-dispute-radio-button-click',
    ACCEPT_DISPUTE_SUBMIT: 'accept-dispute-submit',
    CONTEST_DISPUTE_SUBMIT: 'contest-dispute-submit',
    UPLOAD_MORE_EVIDENCE_SUBMIT: 'upload-more-evidence-submit',
  },
  CASE_ACTIVITY_MODAL: {
    CASE_ACTIVITY_MODAL_SUBMIT: 'dispute-remarks-submit',
  },
  SETTLEMENTS: {
    VIEW: 'settlements_menu_click',
    SETTLEMENT_HOLIDAY: 'settlements_view_holidays_list',
    KNOW_MORE: 'on_demand_settlements_know_more_click',
    REFRESH: 'on_demand_settlements_refresh_click',
    SETTLE_NOW: 'on_demand_settlements_settle_now_button_click',
    INFO_ICON: 'on_demand_settlements_info_icon_hover',
    MODAL_CLOSE: 'on_demand_settlements_modal_close',
    REQUEST_ACTIVATION: 'on_demand_settlements_request_activation_click',
    TRY_TEST_ENV: 'on_demand_settlements_try_test_env_click',
    REQUESTED: 'on_demand_settlement_settle_now_requested',
    [STANDARD]: {
      VIEW: 'standard_settlements_tab_click',
      DATE_RANGE_FILTER: 'standard_settlements_date_range_select',
      SEARCH: 'standard_settlements_search_applied',
      FILTERS: 'standard_settlements_filters_applied',
      PAGE_SIZE: 'standard_settlements_page_size_change',
      SETTLEMENTS_CTA: 'standard_settlements_download_cta_click',
      VIEW_SKIPPED_SETTLEMENTS:
        'standard_settlements_skipped_settlements_toggle',
      UTR_COPIED: 'standard_settlements_copied_UTR',
      VIEW_SETTLEMENT_DETAILS: 'standard_settlements_detailed_view_click',
      DOWNOAD_SETTLEMENT_REPORT:
        'standard_settlements_download_recon_report_click',
    },
    [ON_DEMAND]: {
      VIEW: 'on_demand_settlements_tab_click',
      DATE_RANGE_FILTER: 'on_demand_settlements_date_range_select',
      SEARCH: 'on_demand_settlements_search_applied',
      FILTERS: 'on_demand_settlements_filters_applied',
      PAGE_SIZE: 'on_demand_settlements_page_size_change',
    },
    [INSTANT]: {
      VIEW: 'instant_settlements_tab_click',
      DATE_RANGE_FILTER: 'instant_settlements_date_range_select',
      SEARCH: 'instant_settlements_search_applied',
      FILTERS: 'instant_settlements_filters_applied',
      PAGE_SIZE: 'instant_settlements_page_size_change',
      ACTIVATE_INSTANTLY: 'instant_settlements_activate_instantly_click',
      CONFIRM_ACTIVATION: 'instant_settlements_confirm_activation_click',
      CONFIGURE_INSTANT_SETTLEMENTS: 'instant_settlements_configuration',
      CLOSE_CONFIRM_ACTIVATION_MODAL:
        'instant_settlements_close_confirm_activation_modal_click',
      HAVE_ANY_QUESTIONS: 'instant_settlements_have_any_questions_click',
      ACTIVATE_INSTANTLY_FROM_FAQ_MODAL:
        'instant_settlements_activate_instantly_from_faq_modal_click',
      VIEW_FAQ_ANSWER: 'instant_settlements_view_faq_answer',
      HIDE_ACTIVATION_BANNER: 'instant_settlements_hide_activation_banner',
      WATCH_KNOWLEDGE_VIDEO: 'instant_settlements_watch_knowledge_video',
    },
    [VENDOR]: {
      VIEW: 'vendor_settlements_tab_click',
      SEARCH: 'vendor_settlements_search_applied',
      FILTERS: 'vendor_settlements_filters_applied',
      PAGE_SIZE: 'vendor_settlements_page_size_change',
      SETTLEMENTS_CTA: 'vendor_settlements_download_cta_click',
    },
  },
  PAYMENT_VERIFICATION: {
    VIEW: 'payment_verification_menu_click',
    TABLE_ROW_CLICK: 'payment_verification_table_row_click',
    [ACTION_REQUIRED]: {
      VIEW: 'action_required_tab_click',
      DUE_TODAY_CARD_CLICK: 'due_today_card_clicked',
      DUE_TOMORROW_CARD_CLICK: 'due_tomorrow_card_clicked',
      INSUFFICIENT_EVIDENCE_CARD_CLICK: 'insufficient_evidence_card_clicked',
    },
    [UNDER_REVIEW]: {
      VIEW: 'under_review_tab_click',
    },
    [VERIFIED]: {
      VIEW: 'verified_tab_click',
    },
    [EXPIRED]: {
      VIEW: 'expired_tab_click',
    },
    [ALL]: {
      VIEW: 'all_tab_click',
    },
  },
  PAYMENT_VERIFICATION_DETAILS: {
    VIEW: 'payment_verification_details_page_view',
  },
  EASY_SPLIT: {
    VIEW: 'easy_split_menu_click',
    SEARCH: 'easy_split_search_applied',
    FILTERS: 'easy_split_filters_applied',
    PAGE_SIZE: 'easy_split_page_size_change',
    DOWNLOAD_SAMPLE_FILE: 'easy_split_download_sample_file_click',
    TOGGLE: 'easy_split_vendor_status_toggle',
    DELETE_VENDOR: 'easy_split_vendor_deleted',
    EDIT_VENDOR: 'easy_split_vendor_edited',
    TRY_TEST_ENV: 'easy_split_try_test_env_click',
    REQUEST_ACTIVATION: 'easy_split_request_activation_click',
    [EASY_SPLIT_SETTLEMENT]: {
      [SCHEDULED]: {
        VIEW: 'scheduled_settlements_tab_click',
        DATE_RANGE_FILTER: 'scheduled_settlements_date_range_select',
        SEARCH: 'scheduled_settlements_search_applied',
        FILTERS: 'scheduled_settlements_filters_applied',
        PAGE_SIZE: 'scheduled_settlements_page_size_change',
        UTR_COPIED: 'scheduled_settlements_copied_UTR',
        VENDOR_ID_COPIED: 'scheduled_settlements_copied_VENDOR_ID',
        SETTLEMENT_ID_COPIED: 'scheduled_settlements_copied_SETTLEMENT_ID',
        VIEW_SETTLEMENT_DETAILS: 'scheduled_settlements_detailed_view_click',
        DOWNOAD_SETTLEMENT_REPORT:
          'scheduled_settlements_download_button_click',
      },
      [ON_DEMAND]: {
        VIEW: 'ondemand_settlements_tab_click',
        DATE_RANGE_FILTER: 'ondemand_settlements_date_range_select',
        SEARCH: 'ondemand_settlements_search_applied',
        FILTERS: 'ondemand_settlements_filters_applied',
        PAGE_SIZE: 'ondemand_settlements_page_size_change',
        UTR_COPIED: 'ondemand_settlements_copied_UTR',
        VIEW_SETTLEMENT_DETAILS: 'ondemand_settlements_detailed_view_click',
        DOWNOAD_SETTLEMENT_REPORT: 'ondemand_settlements_download_button_click',
      },
    },
  },
  REPORTS: {
    VIEW: 'reports_menu_click',
    DATE_RANGE_FILTER: 'reports_date_range_select',
    FILTERS: 'reports_filters_applied',
    PAGE_SIZE: 'reports_page_size_change',
    DOWNLOAD_REPORT: 'reports_download_click',
    SHARE_REPORT: 'reports_share_click',
    DOWNLAOD_SHARE_REPORT: 'sharedreports_download_click',
    DELETE_REPORT: 'report_deleted',
    GENERATED_REPORT: 'report_generated',
    GENERATE_REPORT: 'reports_generate_btn_click',
    REPORT_TYPE: 'report_type_selected',
  },
  [SCHEDULE_REPORT]: {
    EDIT: 'schedule_report_edit_click',
    TOGGLE: 'schedule_report_toggle_click',
    SCHEDULE: 'schedule_report_schedule_cta_click',
    SCHEDULE_SUBMIT: 'schedule_report_schedule_modal_submit',
  },
  SPLIT_SCHEME_CONFIGURATION: {
    VIEW: 'split_scheme_menu_click',
    PAGE_SIZE: 'split_scheme_size_change',
    SPLIT_MODAL: 'create_split_scheme_btn_click',
    EDIT_MODAL: 'edit_split_scheme_btn_click',
    CREATE_SCHEME: 'split_scheme_created',
    EDIT_SCHEME: 'split_scheme_edited',
  },
  PAYMENT_LINK: {
    VIEW_LINK: 'View Payment Link',
    VIEW_LINK_DOCS: 'View Know More Link',
    VIEW_UPI_LINK: 'View UPI Link',
    CREATE_PAYMENT_LINK: 'Create Payment Link',
    CANCEL_PAYMENT_LINK: 'Cancel Payment Link',
    CLOSE_PAYMENT_LINK: 'Close Payment Link',
    COPY_LINK: 'Copy Link',
    EDIT_LINK: 'Edit Link',
    CANCEL_LINK: 'Cancel Link',
    OPEN_SEND_REMINDER: 'Open Send Reminder',
    SEND_REMINDER: 'Send Reminder',
    DOWNLOAD_SAMPLE_FILE: 'Download Sample File',
    CHOOSE_BATCH_FILE: 'Choose Batch File',
    FAILED_BATCH_UPLOAD: 'Failed Batch Upload',
    CREATE_PAYMENT_BATCH: 'Create Payment Batch',
    SUCCESS_BATCH_UPLOAD: 'Success Batch Upload',
    PARTIAL_BATCH_UPLOAD: 'Partial Batch Upload',
    CLICK_PROCEED_ANYWAY: 'Click Proceed Anyway',
    DOWNLOAD_ERROR_LOGS: 'Download Error Logs',
    CANCEL_BATCH_UPLOAD: 'Cancel Batch Upload',
    DOWNLOAD_BATCH_FILE: 'Download Batch File',
    SEARCH_LINK: 'Search Link',
    FILTER_DATES_LINK: 'Filter Date Link',
    SEARCH_ORDER: 'Search Order',
    FILTER_DATES_ORDER: 'Filter Dates Order',
  },
  PAYMENT_FORMS: {
    VIEW_FORM: 'View Payment Form',
    VIEW_FORM_DOCS: 'View Payment Form Docs',
    CLICK_CREATE_FORM: 'Click Create Form',
    CREATE_PAYMENT_FORMS: 'Create Payment Form',
    CREATED_PAYMENT_FORMS: 'Created Payment Form',
    CANCEL_PAYMENT_FORMS: 'Cancel Payment Form',
    FAILED_PAYMENT_FORMS: 'Failed Payment Form',
    OPEN_SHARE_FORM: 'Open Share Payment Form',
    SHARE_FORM: 'Share Payment Form',
    EDIT_FORM: 'Edit Payment Form',
    CANCEL_FORM: 'Cancel Payment Form',
    SEARCH_FORM: 'Search Form',
    FILTER_DATES_FORM: 'Filter Date Form',
    SEARCH_ORDER: 'Search Order Form',
    FILTER_DATES_ORDER: 'Filter Dates Order Form',
  },
  INTELLI_FORMS: {
    CLICK_CREATE_FORM: 'Click Create Intelli Form',
    CREATE_INTELLI_FORMS: 'Create Intelli Form',
    CREATED_INTELLI_FORMS: 'Created Intelli Form',
    CANCEL_INTELLI_FORMS: 'Cancel Intelli Form',
    FAILED_INTELLI_FORMS: 'Failed Intelli Form',
  },
  API_RESPONSE_TIME: 'api_response_time',
  VOTE_API_LOGS: 'api_logs_upvote',
  SETTINGS: {
    VIEW: 'settings_global_menu_click',
    EMAIL_NOTIFICATION: {
      MERCHANT_NOTIFICATION: {
        ADD_RECIPIENT: 'add_recipient_button_click',
        RECIPIENT_SUBMIT: 'recipient_added_successfully',
        TOGGLE_CLICK: 'toggle_button_click',
      },
      CUSTOMER_NOTIFICATION: {
        TOGGLE_CLICK: 'toggle_button_click',
      },
    },
  },
  // ROUTER: {
  //   VIEW: 'router_global_menu_click',
  // },
  DEVELOPERS: {
    VIEW: 'developers_global_menu_click',
    BUTTON_VIEW: 'developers_pg_button_click',
    COMMON_BUTTON_VIEW: 'common_developers_pg_button_click',
  },
  'STATUS-PAGE': {
    VIEW: 'status_page_global_menu_click',
    BUTTON_VIEW: 'status_page_pg_button_click',
    COMMON_BUTTON_VIEW: 'common_status_page_pg_button_click',
  },
  PAYMENT_METHODS: {
    ENABLE: 'payment_mode_enable_btn_click',
    STANDARD_PRICING: 'payment_methods_page_standard_pricing_click',
    ENABLE_PAYMENT_MODE_STANDARD_PRICING:
      'enable_payment_mode_standard_pricing_click',
    MODE_ENABLE: 'payment_mode_enable_mode',
    VIEW_HISTORY: 'payment_mode_view_history',
    VIEW_PAYMENTS_PAGE: 'payment_mode_view_payments_page',
    STEP_1_CLICK: 'payment_mode_step_1_clicked',
    STEP_2_SUBMIT: 'payment_mode_step_2_submit',
    CONNECT_PAYPAL: 'payment_methods_connect_paypal_click',
    RESET_PAYPAL: 'payment_methods_reset_paypal_click',
    RESET_PAYTM: 'payment_methods_reset_paytm_click',
    DEFAULT_CURRENCY: 'payment_methods_default_currency_change',
    ACTIVE_CURRENCY: 'payment_methods_active_currency_change',
    DEACTIVATE_PAYPAL_CURRENCY: 'payment_methods_deactivate_paypal_currency',
    TOGGLE_CLICK: 'payment_methods_toggle_click',
    MENU_CLICK: 'payment_methods_menu_click',
    UPLOAD_DOCUMENTS_SUBMIT: 'payment_methods_upload_documents_submit',
    CONNECT_PAYTM: 'payment_methods_connect_paytm_click',
    ADD_PAYTM_TEST_CONFIG: 'payment_methods_add_paytm_test_config',
    ADD_PAYTM_PROD_CONFIG: 'payment_methods_add_paytm_prod_config',
    TEST_PAYTM_TRANSACTION: 'payment_methods_test_paytm_transactions',
    UPDATE_TEST_API_CREDENTIALS: 'payment_methods_update_test_api_credentials',
    SEARCH: 'payment_methods_search_applied',
    FILTERS: 'payment_methods_filter_applied',
  },
  BRANDING: {
    LOGO_COLOUR_CHANGE: 'branding_logo_colour_change',
  },
  API_KEYS: {
    VIEW: 'pg_api_keys_menu_click',
    LOAD: 'pg_developers_page_load',
    GENERATE_BTN: 'pg_api_keys_generate_btn_click',
    GENERATED: 'pg_api_key_generated',
    VIEW_API_KEY: 'pg_api_keys_view_click',
    RESET_API_KEY: 'pg_api_keys_reset_click',
    RESET_BTN: 'pg_api_keys_reset_btn_click',
    RESET_SUCCESS: 'pg_api_keys_reset_success',
    APP_ID_COPY: 'pg_api_keys_app_id_copied',
    SECRET_KEY_COPY: 'pg_api_keys_secret_key_copied',
    DOWNLOAD: 'pg_api_keys_download_click',
    AUTHENTICATED: 'pg_api_keys_view_authenticated',
  },
  CHECKOUT_ANALYTICS: {
    VIEW: 'pg_checkout_analytics_menu_click',
    LOAD: 'pg_developers_page_load',
  },
  WEBHOOKS: {
    VIEW: 'pg_webhooks_menu_click',
    LOAD: 'pg_developers_page_load',
    [CONFIGURATION]: {
      VIEW: 'pg_webhooks_configuration_click',
    },
    [ANALYTICS]: {
      VIEW: 'pg_webhook_analytics_tab_click',
      [DEFAULT]: {
        DATE_RANGE_FILTER: 'pg_webhook_analytics_date_range_select',
        SEARCH: 'pg_webhook_analytics_search_applied',
        FILTERS: 'pg_webhook_analytics_filters_applied',
        PAGE_SIZE: 'pg_webhook_analytics_page_size_change',
      },
    },
    [LOGS]: {
      VIEW: 'pg_webhook_logs_tab_click',
      [DEFAULT]: {
        DATE_RANGE_FILTER: 'pg_webhook_analytics_date_range_select',
        SEARCH: 'pg_webhook_analytics_search_applied',
        FILTERS: 'pg_webhook_analytics_filters_applied',
        PAGE_SIZE: 'pg_webhook_analytics_page_size_change',
      },
      SUCCESS: {
        VIEW: 'pg_webhook_logs_success_tab_click',
        ROW_CLICK: 'pg_webhook_logs_success_row_click',
      },
      FAILED: {
        VIEW: 'pg_webhook_logs_failed_tab_click',
        ROW_CLICK: 'pg_webhook_logs_success_row_click',
      },
      ALL: {
        VIEW: 'pg_webhook_logs_all_tab_click',
        ROW_CLICK: 'pg_webhook_logs_success_row_click',
      },
    },
    [SERVICE_ALERTS]: {
      VIEW: 'pg_service_alerts_menu_click',
      TEST: 'pg_service_alerts_webhook_test',
      ADD: 'pg_service_alerts_webhook_add',
    },
  },
  API_LOGS_AND_METRICS: {
    [LOGS]: {
      VIEW: 'pg_api_metrics_logs_menu_click',
    },
    [ALERTS]: {
      VIEW: 'pg_api_metrics_alerts_menu_click',
    },
  },
  API_METRICS: {
    VIEW: 'pg_api_metrics_menu_click',
    LOAD: 'pg_developers_page_load',
    INTERACT: 'pg_api_metrics_interact',
  },
  WHITELISTING: {
    VIEW: 'pg_whitelisting_menu_click',
    LOAD: 'pg_developers_page_load',
    TYPE_CHANGE: 'pg_whitelisting_type_change',
    ADD_CLICK: 'pg_whitelisting_request',
  },
  INTEGRATION_USAGE: {
    VIEW: 'pg_integration_usage_menu_click',
    LOAD: 'pg_developers_page_load',
  },
  RATE_LIMITS: {
    VIEW: 'pg_rate_limits_menu_click',
    LOAD: 'pg_developers_page_load',
    API_FILTER_CHANGE: 'pg_rate_limits_api_filter_change',
    RANGE_FILTER_CHANGE: 'pg_rate_limits_range_filter_change',
    DOWNLOAD_CLICK: 'pg_graph_download',
    TABLE_ROW_CLICK: 'table_row_click',
  },
  COMMUNICATION_PREFERENCES: {
    LOAD: 'pg_comm_preferences_load',
    ADD: 'pg_comm_preferences_add',
  },
  FAQ_PRIME: {
    CTA_CLICK: 'FAQ Notification clicked',
    CLOSE_CLICK: 'FAQ Notification closed',
    SHOWN: 'FAQ Notification Shown',
    HELP_CTA_CLICK: 'CDB_Help_Clicked',
  },
  TRY_TEST_ENV_BUTTON: 'try_test-env_button',
  APPS: {
    VIEW: 'pg_apps_menu_click',
    OPEN_SLACK_INSTALL: 'pg_apps_slack_install',
    OPEN_SHOPIFY_INSTALL: 'pg_apps_shopify_install',
  },
  [ROUTER]: {
    VIEW: 'router_menu_click',
    REQUEST_ACTIVATION: 'router_request_activation_click',
    [GATEWAYS_CONFIGURATION]: {
      VIEW: 'pg_router_configure_click',
      ADD_CONFIGURATION: 'pg_router_add_configuration_click',
      ADD_CONFIGURATION_TEMPLATE: 'pg_router_add_configuration_template_click',
      ADD_CONFIGURATION_SUBMIT: 'pg_router_add_configuration_submit',
      CREATE_DRAFT_CONFIGURATION_SUBMIT:
        'pg_router_create_draft_configuration_submit',
      TOGGLE_CLICK: 'pg_router_rule_configuration_toggle_click',
      DELETE_CONFIGURATION: 'pg_router_rule_configuration_delete_click',
      DELETE_CONFIGURATION_SUBMIT:
        'pg_router_rule_configuration_delete_click_submit',
      DUPLICATE_CONFIGURATION:
        'pg_router_rule_configuration_duplicate_configuration_click',
      DUPLICATE_CONFIGURATION_SUBMIT:
        'pg_router_rule_configuration_duplicate_configuration_submit',
      VIEW_CONFIGURATION: 'pg_router_view_configuration',
    },
    [GATEWAYS]: {
      VIEW: 'pg_router_gateways_click',
      ADD_GATEWAY: 'pg_router_add_gateway_click',
      ADD_GATEWAY_SUBMIT: 'pg_router_add_gateway_submit',
      TOGGLE_CLICK: 'pg_router_gateway_toggle_click',
    },
  },
  [ROUTER_ANALYTICS]: {
    VIEW: 'pg_router_analytics_click',
    SHOW_EXPANDED_VIEW: 'pg_router_analytics_show_expanded_view_click',
    TOGGLE_CLICK: 'pg_router_analytics_toggle_click',
    FILTER_APPLIED: 'pg_router_analytics_filters_applied',
  },
  DB_NOTIFICATIONS: {
    NOTIFICATION_BELL: 'CDB_Notification_Bell',
    NOTIFICATION_BANNER: 'CDB_Notification_Banner',
    NOTIFICATION_CLICKED: 'CDB_Notification_Clicked',
  },
  PREFERENCES: {
    SAVE_CHANGES: 'preferences_save_changes_button_click',
  },
  SHELL_V2: {
    NAV_BENTO_CLICKED: 'nav_bento_clicked',
    NAV_SETTINGS_CLICKED: 'nav_settings_clicked',
    NAV_PROFILE_CLICKED: 'nav_profile_clicked',
    NAV_ACCOUNT_SWITCHER_CLICKED: 'nav_account_switcher_clicked',
    NAV_PROFILE_MANAGE_ACCOUNT_CLICKED: 'nav_profile_manage_account_clicked',
    NAV_PROFILE_SIGNOUT_CLICKED: 'nav_profile_signout_clicked',
    NAV_PROFILE_HELP_CENTER_CLICKED: 'nav_profile_help_center_clicked',
    NAV_SIDE_COLLAPSE: 'nav_side_collapse',
    SWITCH_TO_OLD_NAVIGATION: 'switch_to_old_navigation',
  },
  WALLETS: {
    REFUND_WALLET: {
      CREATE_WALLET: 'crete_refund_wallet',
      ADD_MONEY: 'add_money_refund_wallet',
      UPDATE_WALLET_STATUS: 'change_refund_wallet_status',
      REFRESH_WALLET_BALANCE: 'refresh_refund_wallet_balance',
    },
  },
  INSIGHTS_AI: {
    POPUP_BANNER_SHOWN: 'popup_banner_shown',
    POPUP_BANNER_CLOSED: 'popup_banner_closed',
    POPUP_BANNER_CLICKED: 'popup_banner_clicked',
    HOMEPAGE_VIEWED: 'insight_ai_homepage_viewed',
    GATEWAY_ADDED_SUCCESS: 'gateway_added_success',
    SUMMARISE_BUTTON_CLICKED: 'summarise_button_clicked',
    FLOWWISE_HOMEPAGE_BUTTON_CLICKED: 'flowwise_homepage_button_clicked',
    CONFIGURATION_PAGE_VIEWED: 'configuration_page_viewed',
    GATEAWAY_PAGE_VIEWED: 'gateway_page_viewed',
    ANALYTICS_PAGE_VIEWED: 'analytics_page_viewed',
    GATEWAYS_ADDED_COUNT: 'gateways_added_count',
    FLOWWISE_WEBAPP_V2_CLICKED: 'flowwise_webapp_v2_clicked',
    ACTIVE_CONFIGURATION_STATUS: 'active_configuration_status',
  },
};
